const sortOptions = {
  FEATURED_NEW_TOP: "FEATURED_NEW_TOP",
  AVAILABILITY: "AVAILABILITY",
  NEAREST: "NEAREST",
  RANKING: "RANKING",
  NEWEST: "NEWEST",
  RATING: "RATING",
  A_Z: "A_Z",
  REVIEW_COUNT: "REVIEW_COUNT",
} as const;

export default sortOptions;

export type SortOption = keyof typeof sortOptions;

export const sortParams = {
  ...sortOptions,
  AVAILABILITY: "REVENUE_WITH_AVAILABILITY",
  NEAREST: undefined,
} as const;

export const sortOptionLabels: { [sortOption in SortOption]: string } = {
  FEATURED_NEW_TOP: "Featured",
  AVAILABILITY: "Available",
  NEAREST: "Nearest",
  RANKING: "Most Popular",
  NEWEST: "New",
  RATING: "Top Rated",
  A_Z: "Alphabetical",
  REVIEW_COUNT: "Number of reviews",
};
